import { createPortal } from 'react-dom';
import Link from 'next/link';
// Components
import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Button from '../../atoms/Button/Button';
// Styles
import styles from './StickyFooterBlock.module.css';

function StickyFooterBlock({
  hasPhoneButton,
  residencePhone,
  ctaLabel,
  ctaLink,
}) {
  const footerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > window.innerHeight && footerRef.current) {
        footerRef.current.classList.add(styles.visible);
      } else if (window.scrollY < window.innerHeight) {
        footerRef.current.classList.remove(styles.visible);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, [footerRef.current]);

  return createPortal(
    <div ref={footerRef} className={styles.stickyFooter}>
      {hasPhoneButton && residencePhone ? (
        <a href={`tel:${residencePhone}`} className={styles.phoneButton} aria-label="appel">
          <Button
            CTAType="secondary"
            outline
            usageContext="light"
            className={styles.ctaPhone}
            icon="call"
          />
        </a>
      ) : null}
      <Link href={`${ctaLink}`} name={ctaLabel} className={styles.ctaLink}>
        <Button
          CTAType="primary"
          usageContext="light"
          className={styles.cta}
        >
          {ctaLabel}
        </Button>
      </Link>
    </div>,
    document.body,
  );
}

StickyFooterBlock.propTypes = {
  ctaLabel: PropTypes.string.isRequired,
  ctaLink: PropTypes.string.isRequired,
  hasPhoneButton: PropTypes.bool,
  residencePhone: PropTypes.string,
};

StickyFooterBlock.defaultProps = {
  hasPhoneButton: false,
  residencePhone: null,
};

export default StickyFooterBlock;
